export interface Project {
  id: string;
  title: string;
  description: string;
  shortDescription: string;
  technologies: string[];
  achievements: string[];
  insights: string[];
  period?: string;
  award?: string;
  github?: string;
  demo?: string;
}

export const projects: Project[] = [
  {
    id: 'runway',
    title: 'Runway',
    shortDescription: 'CMC 12th 대상 수상작 - 이미지 최적화 및 CDN 도입으로 성능 90% 개선',
    description: '이미지 기반 콘텐츠 플랫폼으로, 대용량 이미지 처리와 전역 서비스 제공을 위한 성능 최적화에 집중한 프로젝트입니다. 이미지 리사이징 자동화와 AWS CloudFront CDN 도입을 통해 로딩 시간을 대폭 단축하고 사용자 경험을 개선했습니다.',
    technologies: ['Spring Boot', 'Java', 'AWS S3', 'AWS CloudFront', 'Image Processing', 'JPA', 'MySQL', 'Redis'],
    achievements: [
      '이미지 업로드 시 자동 리사이징 파이프라인 구축으로 원본 대비 90% 용량 감소',
      'AWS CloudFront CDN 도입으로 이미지 로딩 시간 90% 단축 (평균 3초 → 0.3초)',
      '다양한 해상도별 썸네일 자동 생성으로 모바일/데스크톱 최적화',
      'Redis 캐싱을 통한 이미지 메타데이터 조회 성능 향상',
      'CMC 12th 대상 수상 (2024)'
    ],
    insights: [
      '이미지 최적화가 웹 성능에 미치는 영향의 중요성을 체감하고, 사용자 이탈률 감소 확인',
      'CDN을 활용한 정적 자원 배포 전략으로 전역 서비스 품질 향상 및 서버 부하 감소',
      '비동기 이미지 처리 작업 큐 도입으로 사용자 요청 응답 시간 개선',
      '성능 모니터링을 통한 지속적인 최적화의 필요성 인식'
    ],
    award: 'CMC 12th 대상'
  },
  {
    id: 'winey',
    title: 'Winey',
    shortDescription: 'Grafana/Prometheus 서버 모니터링 및 협업 필터링 기반 와인 추천 시스템',
    description: '와인 추천 플랫폼으로, Grafana와 Prometheus를 활용한 실시간 서버 모니터링 시스템을 구축하고, 협업 필터링 알고리즘을 적용한 개인화 추천 시스템을 구현했습니다. Redis 캐싱을 통해 추천 성능을 최적화했습니다.',
    technologies: ['Spring Boot', 'Java', 'Grafana', 'Prometheus', 'Redis', 'Collaborative Filtering', 'JPA', 'MySQL', 'Spring Data JPA'],
    achievements: [
      'Prometheus를 활용한 애플리케이션 메트릭 수집 및 커스텀 메트릭 구현',
      'Grafana 대시보드를 통한 실시간 서버 모니터링 및 알림 설정',
      '협업 필터링 알고리즘을 활용한 사용자 기반 와인 추천 시스템 구현',
      'Redis를 활용한 추천 결과 캐싱으로 응답 시간 80% 단축',
      '사용자 행동 데이터 수집 및 분석을 통한 추천 정확도 향상',
      '대용량 데이터 처리 최적화를 위한 배치 처리 시스템 구축'
    ],
    insights: [
      '모니터링 시스템 구축의 중요성과 운영 효율성 향상 체감',
      '메트릭 수집 및 시각화를 통한 시스템 병목 지점 파악 및 성능 개선',
      '추천 시스템 알고리즘의 실전 적용과 정확도 향상을 위한 데이터 품질의 중요성',
      '캐싱 전략이 사용자 경험에 미치는 긍정적 영향 확인',
      '실시간 모니터링을 통한 장애 예방 및 빠른 대응 가능성 확인'
    ]
  },
  {
    id: 'lifolio',
    title: 'Lifolio',
    shortDescription: 'UMC 3rd 우수상 - FCM 알림 및 JWT/Refresh Token 기반 인증 시스템 리드',
    description: '포트폴리오 공유 플랫폼으로, JWT와 Refresh Token을 활용한 안전한 인증 시스템과 FCM 기반 푸시 알림 시스템을 리드하여 구현했습니다. 토큰 기반 인증의 보안성과 사용자 경험의 균형을 고려한 설계를 진행했습니다.',
    technologies: ['Spring Boot', 'Java', 'JWT', 'Refresh Token', 'FCM', 'Spring Security', 'React', 'TypeScript', 'Redis', 'JPA'],
    achievements: [
      'JWT Access Token과 Refresh Token을 분리한 이중 토큰 인증 시스템 구축',
      'Refresh Token Redis 저장을 통한 토큰 관리 및 보안 강화',
      'FCM을 활용한 실시간 푸시 알림 시스템 구현 (포트폴리오 좋아요, 댓글, 팔로우 알림)',
      '토큰 갱신 API를 통한 사용자 세션 유지 및 자동 로그인 기능 구현',
      'Spring Security 필터 체인 커스터마이징으로 JWT 인증 처리',
      '토큰 만료 시간 최적화로 보안성과 사용자 편의성 균형 달성',
      'UMC 3rd 우수상 수상 (2024)'
    ],
    insights: [
      '토큰 기반 인증의 보안성과 사용자 경험의 균형점을 찾는 과정에서 보안 우선 설계의 중요성 학습',
      'Refresh Token을 활용한 세션 관리 전략으로 보안 강화와 사용자 편의성 동시 달성',
      '푸시 알림을 통한 사용자 참여도 향상 및 재방문율 증가 확인',
      'Redis를 활용한 토큰 관리로 확장 가능한 인증 시스템 구축',
      '토큰 탈취 시나리오에 대한 대응 방안 고민 및 구현 경험',
      '모바일과 웹 환경 모두에서 동작하는 통합 인증 시스템 설계의 복잡성 이해'
    ],
    award: 'UMC 3rd 우수상'
  }
];
